import type * as PrimitiveRadixDialog from '@radix-ui/react-dialog';
import { createContext, Dispatch, ReactNode } from 'react';

type Variants = 'full' | 'full-restricted' | 'half' | 'half-restricted' | 'auto';

export interface SheetContextValue {
	id: string;
	isOpen: boolean;
	setIsOpen: Dispatch<boolean>;
	variant: Variants;
	label: ReactNode;
	onOpenAutoFocus?: PrimitiveRadixDialog.DialogContentProps['onOpenAutoFocus'];
	onCloseAutoFocus?: PrimitiveRadixDialog.DialogContentProps['onCloseAutoFocus'];
	onEscapeKeyDown?: PrimitiveRadixDialog.DialogContentProps['onEscapeKeyDown'];
	onPointerDownOutside?: PrimitiveRadixDialog.DialogContentProps['onPointerDownOutside'];
	onInteractOutside?: PrimitiveRadixDialog.DialogContentProps['onInteractOutside'];
	onCloseAnimationEnd?: () => void;
}

export const SheetContext = createContext<SheetContextValue>(undefined as unknown as SheetContextValue);
